import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.qna');
import { normalizeSubscriber, formatSubscriberInput, readSubscriberInput } from "src/libs/portal/season/contact-policy";
import { CONTACT_EMAIL_PATTERN } from "src/libs/portal/season/contact-policy";
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type BuyerConsultStep = 'profile' | 'consult' | 'complete';
type BuyerRightType = 'patentUtility' | 'trademark' | 'design';
type BuyerConsultMode = 'free' | 'specific' | 'requirements';
type BuyerAgreementKey = 'privacyAgreed' | 'specificCommissionAgreed' | 'requirementCommissionAgreed';
type ConsultSubcategory = '판매' | '구매' | '기술가치평가' | '출원·등록·심판' | '기타';

interface QnaItem {
    id: string;
    category: string;
    title: string;
    question: string;
    status: '답변완료' | '상담 접수' | '검토중';
    createdAt: string;
    answer?: string;
}

interface PublicFaq {
    id: string;
    category: string;
    title: string;
    answer: string;
}

interface BuyerModeCard {
    order: string;
    value: BuyerConsultMode;
    subcategory?: ConsultSubcategory;
    label: string;
    title: string;
    description: string;
    notice?: string;
    bullets: string[];
}

interface ClassOption {
    label: string;
    value: string;
}

interface SuggestedRight {
    id: string;
    rightType: string;
    registrationNumber: string;
    title: string;
    summary: string;
    matchRate: number;
    requested?: boolean;
    receiptNo?: string;
}

interface BuyerConsultForm {
    companyName: string;
    managerName: string;
    contactPrefix: string;
    contactNumber: string;
    contact: string;
    email: string;
    privacyAgreed: boolean;
    mode: BuyerConsultMode;
    rightType: BuyerRightType;
    subcategory: ConsultSubcategory;
    freeMessage: string;
    registrationNumber: string;
    desiredPrice: string;
    specificRequest: string;
    specificCommissionAgreed: boolean;
    registrationDateFrom: string;
    registrationDateTo: string;
    applicationDateFrom: string;
    applicationDateTo: string;
    keywords: string;
    technologyDescription: string;
    trademarkClasses: string[];
    designClasses: string[];
    request: string;
    requirementCommissionAgreed: boolean;
}

@Component({
    selector: 'wiz-page-qna',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.qna/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PageQnaComponent implements OnInit {
    public subscriberDisplay = formatSubscriberInput;
    public categories: string[] = ['구매상담', '판매등록', '서류검수', '권리이전', '기타'];
    public contactPrefixes: string[] = ['010', '011', '016', '017', '018', '019'];
    public consultSubcategories: ConsultSubcategory[] = ['판매', '구매', '기술가치평가', '출원·등록·심판', '기타'];
    public form: any = {
        category: '구매상담',
        title: '',
        question: ''
    };
    public buyerConsultModalOpen: boolean = false;
    public buyerConsultStep: BuyerConsultStep = 'profile';
    public buyerConsultReceiptNo: string = '';
    public buyerConsultSubmitting: boolean = false;
    public buyerConsultForm: BuyerConsultForm = this.createBuyerConsultForm();
    public suggestedRights: SuggestedRight[] = [];
    public buyerModes: Array<{ label: string; value: BuyerConsultMode; description: string }> = [
        { label: '자유 상담', value: 'free', description: '자유로운 주제로 상담' },
        { label: '특정 권리 구매', value: 'specific', description: '등록번호가 있는 권리 구매요청' }
    ];
    public buyerModeCards: BuyerModeCard[] = [
        {
            order: '01',
            value: 'free',
            label: '자유 주제',
            title: '상담내용을 자유롭게 기재',
            description: '판매, 구매, 기술가치평가, 출원·등록·심판, 기타 문의처럼 정해진 요건 없이 상담 주제를 남깁니다.',
            notice: '기술거래뿐 아니라 출원·등록·심판 등 지식재산분야 전반적인 절차에 대한 상담도 가능합니다. (변리사가 직접 상담)',
            bullets: ['권리구분 선택', '세부구분 선택', '상담내용 입력']
        },
        {
            order: '02',
            value: 'specific',
            label: '특정 권리',
            title: '등록번호가 있는 권리 구매요청',
            description: '구매를 희망하는 등록번호가 있을 때 특정 지정가와 요청사항을 접수합니다.',
            bullets: ['등록번호 입력', '특정 지정가 입력', '수수료 동의']
        },
        {
            order: '03',
            value: 'free',
            subcategory: '출원·등록·심판',
            label: '지식재산 전반',
            title: '출원·등록·심판 등 지식재산 전반',
            description: '지식재산의 출원부터 등록, 심판까지 전반적인 절차와 대응 방향을 상담합니다.',
            bullets: ['출원 절차', '등록 가능성', '심판 및 대응']
        },
        {
            order: '04',
            value: 'free',
            subcategory: '기술가치평가',
            label: '가치평가',
            title: '기술가치평가',
            description: '보유 기술과 지식재산의 가치평가 목적, 범위, 진행 절차를 상담합니다.',
            bullets: ['평가 목적 확인', '기술·권리 검토', '평가 절차 안내']
        }
    ];
    public buyerRightTypes: Array<{ label: string; value: BuyerRightType; description: string }> = [
        { label: '특허/실용', value: 'patentUtility', description: '기술 키워드와 기술내용 기준' },
        { label: '상표', value: 'trademark', description: '상품류를 필요한 만큼 선택' },
        { label: '디자인', value: 'design', description: '물품류를 필요한 만큼 선택' }
    ];
    public trademarkClasses: ClassOption[] = [
        { label: '1류 - 화학제·수지·비료 등', value: '1류' },
        { label: '2류 - 페인트·염료 등', value: '2류' },
        { label: '3류 - 화장품·세정제 등', value: '3류' },
        { label: '4류 - 공업용 유지·연료 등', value: '4류' },
        { label: '5류 - 의약품·위생용품 등', value: '5류' },
        { label: '6류 - 금속재료·금속제품 등', value: '6류' },
        { label: '7류 - 기계·공작기계 등', value: '7류' },
        { label: '8류 - 수공구·식기류 등', value: '8류' },
        { label: '9류 - 과학·전기·소프트웨어 등', value: '9류' },
        { label: '10류 - 의료기기·보조기구 등', value: '10류' },
        { label: '11류 - 조명·냉난방·위생설비 등', value: '11류' },
        { label: '12류 - 운송수단·부품 등', value: '12류' },
        { label: '13류 - 화기·폭죽 등', value: '13류' },
        { label: '14류 - 귀금속·시계 등', value: '14류' },
        { label: '15류 - 악기 등', value: '15류' },
        { label: '16류 - 종이·인쇄물 등', value: '16류' },
        { label: '17류 - 고무·플라스틱 재료 등', value: '17류' },
        { label: '18류 - 가죽·가방 등', value: '18류' },
        { label: '19류 - 비금속 건축재료 등', value: '19류' },
        { label: '20류 - 가구·비금속 용기 등', value: '20류' },
        { label: '21류 - 가정·주방용품 등', value: '21류' },
        { label: '22류 - 로프·텐트·섬유원료 등', value: '22류' },
        { label: '23류 - 방적사·실 등', value: '23류' },
        { label: '24류 - 직물·침구 등', value: '24류' },
        { label: '25류 - 의류·신발·모자 등', value: '25류' },
        { label: '26류 - 레이스·단추·장식품 등', value: '26류' },
        { label: '27류 - 카펫·벽지 등', value: '27류' },
        { label: '28류 - 게임·완구·운동용품 등', value: '28류' },
        { label: '29류 - 육류·가공식품 등', value: '29류' },
        { label: '30류 - 커피·차·과자 등', value: '30류' },
        { label: '31류 - 농산물·신선식품 등', value: '31류' },
        { label: '32류 - 맥주·비알코올음료 등', value: '32류' },
        { label: '33류 - 주류 등', value: '33류' },
        { label: '34류 - 담배·흡연용품 등', value: '34류' },
        { label: '35류 - 광고·사업관리 등', value: '35류' },
        { label: '36류 - 보험·금융·부동산 등', value: '36류' },
        { label: '37류 - 건설·수리업 등', value: '37류' },
        { label: '38류 - 통신업 등', value: '38류' },
        { label: '39류 - 운송·보관·여행업 등', value: '39류' },
        { label: '40류 - 재료처리업 등', value: '40류' },
        { label: '41류 - 교육·엔터테인먼트 등', value: '41류' },
        { label: '42류 - 과학·기술·디자인 등', value: '42류' },
        { label: '43류 - 음식·숙박업 등', value: '43류' },
        { label: '44류 - 의료·헬스·조경업 등', value: '44류' },
        { label: '45류 - 법률·경비·장의업 등', value: '45류' }
    ];
    public designClasses: ClassOption[] = [
        { label: '1류 - 식품', value: '1류' },
        { label: '2류 - 의류 및 패션잡화용품', value: '2류' },
        { label: '3류 - 여행용품·케이스·개인용품', value: '3류' },
        { label: '4류 - 브러시류', value: '4류' },
        { label: '5류 - 섬유제품·인조천연 시트', value: '5류' },
        { label: '6류 - 가구 및 침구류', value: '6류' },
        { label: '7류 - 가정용품·주방용품', value: '7류' },
        { label: '8류 - 공구·철물류', value: '8류' },
        { label: '9류 - 포장용기·운반용기', value: '9류' },
        { label: '10류 - 시계·측정기기', value: '10류' },
        { label: '11류 - 장식용품', value: '11류' },
        { label: '12류 - 운송·승강수단', value: '12류' },
        { label: '13류 - 전기 발생·분배·변환기기', value: '13류' },
        { label: '14류 - 기록·통신·정보검색기기', value: '14류' },
        { label: '15류 - 기타 기계류', value: '15류' },
        { label: '16류 - 사진·영상·광학기기', value: '16류' },
        { label: '17류 - 악기', value: '17류' },
        { label: '18류 - 인쇄·사무용 기계', value: '18류' },
        { label: '19류 - 문방구·사무용품·교재', value: '19류' },
        { label: '20류 - 판매·광고용품·표지판', value: '20류' },
        { label: '21류 - 게임·완구·스포츠용품', value: '21류' },
        { label: '22류 - 무기·화약·사냥·낚시용품', value: '22류' },
        { label: '23류 - 유체공급·위생·난방·환기기기', value: '23류' },
        { label: '24류 - 의료·실험실용 기기', value: '24류' },
        { label: '25류 - 건축 유닛·건설자재', value: '25류' },
        { label: '26류 - 조명기기', value: '26류' },
        { label: '27류 - 담배 및 흡연용품', value: '27류' },
        { label: '28류 - 의약품·화장품·위생용품', value: '28류' },
        { label: '29류 - 화재·위험방지·구조용품', value: '29류' },
        { label: '30류 - 동물관리 및 사육용품', value: '30류' },
        { label: '31류 - 기타 조리용 기계·기구', value: '31류' }
    ];

    public publicFaqs: PublicFaq[] = [
        {
            id: 'FAQ-001',
            category: '구매상담',
            title: '판매자 연락처는 바로 확인할 수 있나요?',
            answer: '공개 화면에서는 판매자 개인정보를 표시하지 않습니다. 구매상담을 접수하면 웅빈이 권리자 의사와 서류를 확인한 뒤 필요한 범위에서 중개합니다.'
        },
        {
            id: 'FAQ-002',
            category: '판매등록',
            title: '등록원부나 등록공고문이 없어도 먼저 신청할 수 있나요?',
            answer: '초기 신청은 가능하지만 공개 전 검수 단계에서 권리증, 등록원부, 등록공고문 확인이 필요합니다. 누락된 서류는 보완 요청으로 안내됩니다.'
        },
        {
            id: 'FAQ-003',
            category: '권리이전',
            title: '바로 결제해서 권리를 사는 방식인가요?',
            answer: '아닙니다. IP 거래소는 바로 결제 구조가 아니라 상담 접수, 권리 검토, 조건 협의, 중개 절차를 거쳐 거래 가능성을 확인하는 방식입니다.'
        },
        {
            id: 'FAQ-004',
            category: 'AI/KIPRIS',
            title: '거래소에 없는 권리도 찾을 수 있나요?',
            answer: 'AI/KIPRIS 검색 화면에서 외부 등록권 mock 결과를 확인하고 매입 가능성 조사 요청을 남길 수 있습니다. 실제 외부 조사는 백엔드 연동 단계에서 처리됩니다.'
        }
    ];
    public qnas: QnaItem[] = [
        {
            id: 'QNA-001',
            category: '구매상담',
            title: '상표권 구매 시 권리자 정보는 언제 확인할 수 있나요?',
            question: '관심 상표가 있는데 목록에서는 판매자 정보가 보이지 않습니다.',
            status: '답변완료',
            createdAt: '2026-06-29',
            answer: '판매자 개인정보는 공개하지 않습니다. 상담 접수 후 웅빈이 권리자 의사와 서류를 확인하고 필요한 범위에서 중개 절차를 안내합니다.'
        },
        {
            id: 'QNA-002',
            category: '판매등록',
            title: '등록원부 파일이 없어도 신청할 수 있나요?',
            question: '권리증은 있는데 등록원부를 아직 준비하지 못했습니다.',
            status: '답변완료',
            createdAt: '2026-06-28',
            answer: '초기 신청은 가능하지만 공개 전 검수 단계에서 등록원부 확인이 필요합니다. 누락 서류는 보완 요청 상태로 안내됩니다.'
        },
        {
            id: 'QNA-003',
            category: '서류검수',
            title: '검수 대기 상태는 어느 정도 걸리나요?',
            question: '판매 신청 후 공개까지 예상 기간이 궁금합니다.',
            status: '검토중',
            createdAt: '2026-06-30'
        }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow('/market/cases')) return;
        await this.service.render();
    }

    public async openBuyerConsultModal(mode: BuyerConsultMode = 'free', subcategory?: ConsultSubcategory) {
        this.buyerConsultForm = this.createBuyerConsultForm();
        this.buyerConsultForm.mode = mode;
        if (subcategory) this.buyerConsultForm.subcategory = subcategory;
        this.buyerConsultStep = 'profile';
        this.buyerConsultReceiptNo = '';
        this.buyerConsultSubmitting = false;
        this.suggestedRights = [];
        this.buyerConsultModalOpen = true;
        await this.service.render();
    }

    public async closeBuyerConsultModal() {
        this.buyerConsultModalOpen = false;
        this.buyerConsultForm = this.createBuyerConsultForm();
        this.buyerConsultStep = 'profile';
        this.buyerConsultReceiptNo = '';
        this.buyerConsultSubmitting = false;
        this.suggestedRights = [];
        await this.service.render();
    }

    public async goBuyerProfileStep() {
        this.buyerConsultStep = 'profile';
        await this.service.render();
    }

    public async goBuyerConsultStep() {
        if (!(await this.validateBuyerProfile())) return;

        this.buyerConsultStep = 'consult';
        await this.service.render();
    }

    public buyerStepClass(step: BuyerConsultStep) {
        const order: Record<BuyerConsultStep, number> = { profile: 1, consult: 2, complete: 3 };
        if (this.buyerConsultStep === step) return 'border-cyan-700 bg-cyan-700 text-white';
        if (order[this.buyerConsultStep] > order[step]) return 'border-cyan-200 bg-cyan-50 text-cyan-800';
        return 'border-slate-200 bg-white text-slate-500';
    }

    public async toggleBuyerAgreement(key: BuyerAgreementKey) {
        this.buyerConsultForm[key] = !this.buyerConsultForm[key];
        await this.service.render();
    }

    public async onBuyerContactNumberInput(event: any) {
        const value = readSubscriberInput(event);
        this.buyerConsultForm.contactNumber = value;
        event.target.value = value;
        this.syncBuyerContact();
        await this.service.render();
    }

    public async selectBuyerMode(mode: BuyerConsultMode) {
        this.buyerConsultForm.mode = mode;
        this.suggestedRights = [];
        await this.service.render();
    }

    public async selectBuyerRightType(type: BuyerRightType) {
        this.buyerConsultForm.rightType = type;
        await this.service.render();
    }

    public isBuyerTrademarkClassSelected(classValue: string) {
        return this.buyerConsultForm.trademarkClasses.includes(classValue);
    }

    public async toggleBuyerTrademarkClass(classValue: string) {
        this.buyerConsultForm.trademarkClasses = this.toggleListItem(this.buyerConsultForm.trademarkClasses, classValue);
        await this.service.render();
    }

    public isBuyerDesignClassSelected(classValue: string) {
        return this.buyerConsultForm.designClasses.includes(classValue);
    }

    public async toggleBuyerDesignClass(classValue: string) {
        this.buyerConsultForm.designClasses = this.toggleListItem(this.buyerConsultForm.designClasses, classValue);
        await this.service.render();
    }

    public buyerRightTypeLabel(type: BuyerRightType = this.buyerConsultForm.rightType) {
        if (type === 'patentUtility') return '특허/실용';
        if (type === 'trademark') return '상표';
        return '디자인';
    }

    public buyerModeLabel(mode: BuyerConsultMode = this.buyerConsultForm.mode) {
        if (mode === 'free') return '자유 상담';
        if (mode === 'specific') return '특정 권리 구매요청';
        return '요건 기반 구매요청';
    }

    public buyerConsultTitle() {
        return this.buyerConsultForm.mode === 'free' ? '자유상담 신청' : '구매상담 신청';
    }

    public buyerConsultDescription() {
        return this.buyerConsultForm.mode === 'free'
            ? '의뢰인 정보 확인 후 상담 형태를 선택합니다.'
            : '구매자 정보 확인 후 상담 형태를 선택합니다.';
    }

    public buyerProfileLabel() {
        return this.buyerConsultForm.mode === 'free' ? '의뢰인 정보' : '구매자 정보';
    }

    public async submitBuyerConsult() {
        if (!(await this.validateBuyerConsult())) return;

        this.syncBuyerContact();
        const flow = this.buyerConsultForm.mode === 'free'
            ? 'general_qna'
            : this.buyerConsultForm.mode === 'specific'
                ? 'right_specific_qna'
                : 'requirement_qna';
        this.buyerConsultSubmitting = true;
        await this.service.render();
        const { code, data } = await wiz.call('submit_consultation', {
            payload: JSON.stringify({
                flow,
                data: this.buyerConsultPayload(this.buyerConsultDetails())
            })
        });
        this.buyerConsultSubmitting = false;
        if (code !== 200) {
            await this.service.modal.error(this.consultationError(data));
            await this.service.render();
            return;
        }

        this.buyerConsultReceiptNo = data.receiptNo;
        this.suggestedRights = this.buyerConsultForm.mode === 'requirements' ? this.createSuggestedRights() : [];
        const next: QnaItem = {
            id: `QNA-${String(this.qnas.length + 1).padStart(3, '0')}`,
            category: this.buyerConsultForm.mode === 'free' ? '자유상담' : '구매상담',
            title: this.buyerModeLabel(this.buyerConsultForm.mode),
            question: this.createBuyerConsultSummary(),
            status: '상담 접수',
            createdAt: this.todayLabel()
        };
        this.qnas = [next, ...this.qnas];
        if (this.buyerConsultForm.mode !== 'requirements') {
            this.clearBuyerPersonalData();
        }
        this.buyerConsultStep = 'complete';
        await this.service.render();
    }

    public async requestSuggestedRight(right: SuggestedRight) {
        if (right.requested || this.buyerConsultSubmitting) return;
        this.buyerConsultSubmitting = true;
        await this.service.render();
        const { code, data } = await wiz.call('submit_consultation', {
            payload: JSON.stringify({
                flow: 'ai_candidate_consultation',
                data: this.buyerConsultPayload({
                    candidateId: right.id,
                    rightTitle: right.title,
                    registrationNumber: right.registrationNumber,
                    rightType: right.rightType,
                    matchRate: right.matchRate,
                    summary: right.summary,
                    request: '요건 기반 상담에서 선택한 후보 권리의 구매 가능성 검토를 요청합니다.',
                    parentReceiptNo: this.buyerConsultReceiptNo
                }, false)
            })
        });
        this.buyerConsultSubmitting = false;
        if (code !== 200) {
            await this.service.modal.error(this.consultationError(data));
            await this.service.render();
            return;
        }

        right.requested = true;
        right.receiptNo = data.receiptNo;
        await this.service.modal.success(`선택한 등록권리 상담이 접수되었습니다. 접수번호: ${right.receiptNo}`);
        await this.service.render();
    }

    public async submit() {
        if (!this.form.title || !this.form.question) {
            await this.service.modal.error('문의 제목과 내용을 입력해주세요.');
            return;
        }

        const next: QnaItem = {
            id: `QNA-${String(this.qnas.length + 1).padStart(3, '0')}`,
            category: this.form.category,
            title: this.form.title,
            question: this.form.question,
            status: '상담 접수',
            createdAt: this.todayLabel()
        };
        this.qnas = [next, ...this.qnas];
        this.form = { category: '구매상담', title: '', question: '' };
        await this.service.render();
    }

    public statusClass(status: string) {
        if (status === '답변완료') return 'bg-emerald-50 text-emerald-700 border-emerald-200';
        if (status === '검토중') return 'bg-amber-50 text-amber-700 border-amber-200';
        return 'bg-cyan-50 text-cyan-700 border-cyan-200';
    }

    private async validateBuyerProfile() {
        if (!this.buyerConsultForm.companyName.trim() || !this.buyerConsultForm.managerName.trim() || !this.buyerConsultForm.contactNumber.trim() || !this.buyerConsultForm.email.trim()) {
            await this.service.modal.error('회사/성명, 담당자, 연락처, 이메일을 입력해주세요.');
            return false;
        }

        if (normalizeSubscriber(this.buyerConsultForm.contactNumber) === null) {
            await this.service.modal.error('연락처는 앞자리를 선택하고 나머지 숫자 8자리를 입력해주세요.');
            return false;
        }

        if (!this.isValidEmail(this.buyerConsultForm.email)) {
            await this.service.modal.error('이메일 형식으로 입력해주세요.');
            return false;
        }

        if (!this.buyerConsultForm.privacyAgreed) {
            await this.service.modal.error('개인정보 수집 및 이용에 동의해주세요.');
            return false;
        }

        this.syncBuyerContact();
        return true;
    }

    private async validateBuyerConsult() {
        const form = this.buyerConsultForm;

        if (form.mode === 'free') {
            if (!form.freeMessage.trim()) {
                await this.service.modal.error('상담내용을 입력해주세요.');
                return false;
            }
            return true;
        }

        if (form.mode === 'specific') {
            if (!form.registrationNumber.trim() || !form.desiredPrice.trim()) {
                await this.service.modal.error('등록번호와 특정 지정가를 입력해주세요.');
                return false;
            }
            if (form.rightType === 'trademark' && !form.trademarkClasses.length) {
                await this.service.modal.error('상표 류를 1개 이상 선택해주세요.');
                return false;
            }
            if (form.rightType === 'design' && !form.designClasses.length) {
                await this.service.modal.error('디자인 류를 1개 이상 선택해주세요.');
                return false;
            }
            if (!form.specificCommissionAgreed) {
                await this.service.modal.error('최종 거래 수수료 항목에 동의해주세요.');
                return false;
            }
            return true;
        }

        if (form.rightType === 'patentUtility' && !form.keywords.trim()) {
            await this.service.modal.error('특허/실용 핵심단어를 입력해주세요.');
            return false;
        }

        if (form.technologyDescription.length > 300) {
            await this.service.modal.error('기술내용은 300자 이내로 입력해주세요.');
            return false;
        }

        if (form.rightType === 'trademark' && !form.trademarkClasses.length) {
            await this.service.modal.error('상표 류를 1개 이상 선택해주세요.');
            return false;
        }

        if (form.rightType === 'design' && !form.designClasses.length) {
            await this.service.modal.error('디자인 류를 1개 이상 선택해주세요.');
            return false;
        }

        if (!form.requirementCommissionAgreed) {
            await this.service.modal.error('최종 거래 수수료 항목에 동의해주세요.');
            return false;
        }

        return true;
    }

    private createBuyerConsultSummary() {
        const form = this.buyerConsultForm;
        const details: string[] = [
            `상담유형: ${this.buyerModeLabel(form.mode)}`,
            `권리구분: ${this.buyerRightTypeLabel(form.rightType)}`
        ];

        if (form.mode === 'free') {
            details.push(`세부구분: ${form.subcategory}`);
            if (form.rightType === 'trademark' && form.trademarkClasses.length) details.push(`상표류: ${form.trademarkClasses.join(', ')}`);
            if (form.rightType === 'design' && form.designClasses.length) details.push(`디자인류: ${form.designClasses.join(', ')}`);
            details.push(`상담내용: ${form.freeMessage}`);
            return details.join(' / ');
        }

        if (form.mode === 'specific') {
            details.push(`등록번호: ${form.registrationNumber}`);
            if (form.rightType === 'trademark') details.push(`상표류: ${form.trademarkClasses.join(', ')}`);
            if (form.rightType === 'design') details.push(`디자인류: ${form.designClasses.join(', ')}`);
            details.push(`특정 지정가: ${form.desiredPrice}`);
            if (form.specificRequest) details.push(`요청사항: ${form.specificRequest}`);
            return details.join(' / ');
        }

        if (form.registrationDateFrom || form.registrationDateTo) {
            details.push(`등록일범위: ${form.registrationDateFrom || '미입력'}~${form.registrationDateTo || '미입력'}`);
        }

        if (form.applicationDateFrom || form.applicationDateTo) {
            details.push(`출원일범위: ${form.applicationDateFrom || '미입력'}~${form.applicationDateTo || '미입력'}`);
        }

        if (form.rightType === 'patentUtility') {
            details.push(`핵심단어: ${form.keywords || '미입력'}`);
            if (form.technologyDescription) details.push(`기술내용: ${form.technologyDescription}`);
        }

        if (form.rightType === 'trademark') {
            details.push(`상표류: ${form.trademarkClasses.join(', ')}`);
        }

        if (form.rightType === 'design') {
            details.push(`디자인류: ${form.designClasses.join(', ')}`);
        }

        if (form.request) details.push(`요청사항: ${form.request}`);
        return details.join(' / ');
    }

    private buyerConsultPayload(details: any, feeAgreed: boolean | null = null) {
        const form = this.buyerConsultForm;
        const agreed = feeAgreed === null
            ? form.mode === 'specific'
                ? form.specificCommissionAgreed
                : form.mode === 'requirements' && form.requirementCommissionAgreed
            : feeAgreed;
        return {
            requester: { name: form.managerName.trim(), company: form.companyName.trim() },
            contact: { phone: form.contact, email: form.email.trim() },
            privacyAgreed: form.privacyAgreed,
            feeAgreed: agreed,
            details
        };
    }

    private buyerConsultDetails() {
        const form = this.buyerConsultForm;
        if (form.mode === 'free') {
            return {
                rightType: this.buyerRightTypeLabel(),
                subcategory: form.subcategory,
                trademarkClasses: form.trademarkClasses,
                designClasses: form.designClasses,
                request: form.freeMessage.trim()
            };
        }
        if (form.mode === 'specific') {
            return {
                rightType: this.buyerRightTypeLabel(),
                registrationNumber: form.registrationNumber.trim(),
                desiredPrice: form.desiredPrice.trim(),
                trademarkClasses: form.trademarkClasses,
                designClasses: form.designClasses,
                request: form.specificRequest.trim()
            };
        }
        return {
            rightType: this.buyerRightTypeLabel(),
            registrationDateFrom: form.registrationDateFrom,
            registrationDateTo: form.registrationDateTo,
            applicationDateFrom: form.applicationDateFrom,
            applicationDateTo: form.applicationDateTo,
            keywords: form.keywords.trim(),
            technologyDescription: form.technologyDescription.trim(),
            trademarkClasses: form.trademarkClasses,
            designClasses: form.designClasses,
            request: form.request.trim()
        };
    }

    private createSuggestedRights(): SuggestedRight[] {
        const rightType = this.buyerRightTypeLabel();
        return [
            {
                id: 'MATCH-001',
                rightType,
                registrationNumber: rightType === '상표' ? '40-2054188' : rightType === '디자인' ? '30-1198205' : '10-2489132',
                title: rightType === '상표' ? '헬스케어 예약 서비스 상표권 MEDINAV' : rightType === '디자인' ? '스마트 워크 재킷 외관 디자인' : '저전력 엣지 디바이스 이상 탐지 방법',
                summary: '입력 요건과 높은 관련성이 있는 등록권리 후보입니다.',
                matchRate: 92
            },
            {
                id: 'MATCH-002',
                rightType,
                registrationNumber: rightType === '상표' ? '40-1987721' : rightType === '디자인' ? '30-1124501' : '10-2419033',
                title: rightType === '상표' ? '생활용품 브랜드 상표권 VELLOA' : rightType === '디자인' ? '접이식 전기자전거 프레임 디자인' : '생분해성 포장재 조성물',
                summary: '관리자 검토 후 구매 상담 후보로 제공 가능한 등록권리입니다.',
                matchRate: 86
            },
            {
                id: 'MATCH-003',
                rightType,
                registrationNumber: rightType === '상표' ? '40-1876330' : rightType === '디자인' ? '30-1094210' : '20-0495512',
                title: rightType === '상표' ? '온라인 유통 브랜드 상표권' : rightType === '디자인' ? '휴대형 공기청정기 외관 디자인' : '현장 조립형 배관 고정 브라켓',
                summary: '세부 조건 확인 후 관리자 상담으로 이어질 수 있는 후보입니다.',
                matchRate: 79
            }
        ];
    }

    private createBuyerConsultForm(): BuyerConsultForm {
        return {
            companyName: '',
            managerName: '',
            contactPrefix: '010',
            contactNumber: '',
            contact: '',
            email: '',
            privacyAgreed: false,
            mode: 'free',
            rightType: 'patentUtility',
            subcategory: '구매',
            freeMessage: '',
            registrationNumber: '',
            desiredPrice: '',
            specificRequest: '',
            specificCommissionAgreed: false,
            registrationDateFrom: '',
            registrationDateTo: '',
            applicationDateFrom: '',
            applicationDateTo: '',
            keywords: '',
            technologyDescription: '',
            trademarkClasses: [],
            designClasses: [],
            request: '',
            requirementCommissionAgreed: false
        };
    }

    private toggleListItem(list: string[], item: string) {
        if (list.includes(item)) {
            return list.filter((value) => value !== item);
        }

        return [...list, item];
    }

    private syncBuyerContact() {
        const number = normalizeSubscriber(this.buyerConsultForm.contactNumber) || '';
        this.buyerConsultForm.contact = number.length === 8 ? `${this.buyerConsultForm.contactPrefix}-${number.slice(0, 4)}-${number.slice(4)}` : `${this.buyerConsultForm.contactPrefix}-${number}`;
    }

    private clearBuyerPersonalData() {
        this.buyerConsultForm.companyName = '';
        this.buyerConsultForm.managerName = '';
        this.buyerConsultForm.contactNumber = '';
        this.buyerConsultForm.contact = '';
        this.buyerConsultForm.email = '';
        this.buyerConsultForm.privacyAgreed = false;
    }

    private isValidEmail(email: string) {
        return CONTACT_EMAIL_PATTERN.test((email || '').trim());
    }

    private consultationError(data: any) {
        const message = data?.message || '상담 접수에 실패했습니다.';
        if (data?.errorType === 'validation') return `입력값 오류: ${message}`;
        if (data?.errorType === 'network') return `네트워크 오류: ${message}`;
        return `서버 오류: ${message}`;
    }

    private todayLabel() {
        const now = new Date();
        const year = now.getFullYear();
        const month = `${now.getMonth() + 1}`.padStart(2, '0');
        const date = `${now.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${date}`;
    }
}

export default PageQnaComponent;